module.exports = __webpack_public_path__ + "0e2f7ecc6e7289362c039e1c88bdbbeb.svg";